export default "/assets/ff17528e15be8f32.svg"